export function uniqueLocations(centers) {
  return [...new Set((centers || []).map(center => center.location).filter(Boolean))].sort();
}

export function centersForLocation(centers, location) {
  return (centers || []).filter(center => center.location === location);
}

export function getCenterValidationMessage(center) {
  if (!center) return "";
  if (!center.venue_manager && !center.assistant_venue_manager) {
    return `Venue manager or assistant venue manager is not assigned to ${center.center_name}. Please select the correct center details.`;
  }
  return "";
}

export function getTravelWindow(testDate) {
  if (!testDate) return { start_date: "", end_date: "" };

  const [year, month, day] = testDate.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  const start = new Date(date);
  start.setDate(date.getDate() - 2);
  const end = new Date(date);
  end.setDate(date.getDate() + 2);

  const toDateInput = (value) => {
    const yyyy = value.getFullYear();
    const mm = String(value.getMonth() + 1).padStart(2, "0");
    const dd = String(value.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  return {
    start_date: toDateInput(start),
    end_date: toDateInput(end),
  };
}
